/**
 * @file Overview service util
 * @author XiaoBin Li(lixiaobin8878@gmail.com)
 */

import axios from 'axios'
let querystring = require('querystring')
axios.interceptors.request.use(function (config) {
    // c端的token放在headers中 命名_t
    if (config.data && config.data.token) {
        config.headers['j3'] = config.data.token
    }
    return config
})
/**
 * 添加ajax response interceptor
 */
// eslint-disable-next-line complexity
axios.interceptors.response.use(
    function (res) {
        let data = res.data
        let code = data.code
        if (typeof data === 'string') {
            data = JSON.parse(data)
        }
        if (code === 0 || isNaN(code)) {
            return data
        } else {
            // 需要自定义 reject 处理，就直接 return ，让业务自己处理业务
            if (res.config.Headers && res.config.Headers['custom-reject']) {
                return Promise.reject(data)
            }
            // 未登录状态
            if (code === 1000000500) {
                if (data.data && data.data.redirectUrl) {
                    let url = window.location.href
                    window.location.href =
                        data.data.redirectUrl + encodeURIComponent(url)
                }
                return Promise.reject(data)
            }
            // 不弹toast的错误码，需自己处理
            if (
                code === 2000010086 ||
                code === 1000010003 ||
                code === 1000010004 ||
                code === 1000010002 ||
                code === 1000010001
            ) {
                return Promise.reject(data)
            }
            toast(data.msg || '系统异常', 'error')
            return Promise.reject(data)
        }
    },
    function (error) {
        let response = error.response
        let data = response.data
        // 需要自定义 reject 处理，就直接 return ，让业务自己处理业务
        if (
            response.config.headers &&
            response.config.headers['custom-reject']
        ) {
            return Promise.reject(data)
        }
        let status = error.response.status
        // 401 表明没有权限，跳转到登录页，与 status 200 code为1000000500 逻辑类似
        if (status === 401) {
            let url = window.location.href
            let redirectUrl = data.data.redirectUrl
            if (redirectUrl) {
                window.location.href =
                    data.data.redirectUrl + encodeURIComponent(url)
            } else {
                window.location.href =
                    data.data.redirectUrl ||
                    '/login?url=' + encodeURIComponent(url)
            }
            return Promise.reject(error)
        }
        if (!response) {
            toast('无网络链接，请检查后重试', 'error')
        } else {
            toast(data && data.msg ? data.msg : '系统异常', 'error')
        }
        return Promise.reject(error)
    }
)

/**
 * 发送 post 请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
export function post(url, data = {}) {
    return axios.post(url, querystring.stringify(data))
}

export async function postWithJson(url, data = {}, options = {}) {
    return axios.post(url, data, options)
}

/**
 * post form参数请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
export function form(url, data = {}) {
    return axios.post(url, querystring.stringify(data), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    })
}

/**
 * 发送 delete 请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
export function del(url, data = {}) {
    return axios.delete(url, {
        params: data,
    })
}

/**
 * 发送 get 请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
export function get(url, data = {}) {
    return axios.get(url, {
        params: data,
    })
}

/**
 * 发送 update 请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
export function put(url, data = {}) {
    return axios.put(url, data)
}
